class IntercomUtils {
  static waitForLoad() {
    return new Promise((resolve, reject) => {
      const MAX_ATTEMPTS = 10;
      let attempts = 0;

      const intercomChecker = setInterval(() => {
        if (window.Intercom) {
          clearInterval(intercomChecker);
          resolve(window.Intercom);
        }

        attempts += 1;

        // We've tried enough waiting for Intercom to load. Consider it unavailable.
        if (attempts >= MAX_ATTEMPTS) {
          clearInterval(intercomChecker);
          reject();
        }
      }, 450);
    });
  }

  // Call waitForLoad() before calling this method to avoid window.Intercom to be undefined
  static setLauncherVisibility(visible) {
    if (window.Intercom) {
      window.Intercom('update', { hide_default_launcher: !visible }); // eslint-disable-line new-cap
    }
  }

  static showMessageModal() {
    if (window.Intercom) {
      window.Intercom('showNewMessage'); // eslint-disable-line new-cap
    }
  }

  static hideMessageModal() {
    if (window.Intercom) {
      window.Intercom('hide'); // eslint-disable-line new-cap
    }
  }
}

export default IntercomUtils;
